<template>
    <section id="group-details">
        <template v-if="fetchedInitialGroupDetails && !leaveGroupMode">

            <template v-if="!changeGroupNameMode">
                <div class="group-details" key="group-details">
                    <h1><span v-if="groupDetails.isPublic">Public</span> Group: {{groupDetails.name}}</h1>

                    <a href="#change-group-name" @click.prevent="changeGroupNameMode = true;" v-if="moderatorStatus === 'owner'">Change Group Name</a>
                    <a href="#make-public" @click.prevent="changePublicStatus(true)" v-if="moderatorStatus === 'owner' && !groupDetails.isPublic">Make Group Public</a>
                    <a href="#make-private" @click.prevent="changePublicStatus(false)" v-if="moderatorStatus === 'owner' && groupDetails.isPublic">Make Group Private</a>
                    <a href="#leave-group" @click.prevent="leaveGroupMode = true;">Leave Group</a>
                </div>
            </template>

            <template v-if="changeGroupNameMode">
                <div class="group-update-name" key="group-update-name">
                    <input type="text" placeholder="Group name..." v-model="newGroupName" :disabled="savingNewGroupName"/>
                    <div class="button-container">
                        <button @click.prevent="changeGroupNameMode = false" :disabled="savingNewGroupName">Cancel</button>
                        <button @click.prevent="updateGroupName" :disabled="savingNewGroupName">Submit</button>
                    </div>
                </div>
            </template>

            <h1>
                Members
                <a href="#invite-member" v-if="!inviteMemberMode" @click.prevent="inviteMemberMode = true">
                    <span><i class="fa fa-plus-circle add-member"></i> Invite</span>
                </a>
                <a href="#return-from-invite-member" v-if="inviteMemberMode" @click.prevent="inviteMemberMode = false">
                    <span><i class="fa fa-chevron-circle-left add-member"></i> Return</span>
                </a>
            </h1>

            <section id="members" v-if="!inviteMemberMode">
                <ul>
                    <li v-for="user in groupDetails.members" :key="user.id">
                        <a :href="`/Profile/${user.stringUrl}`" target="_blank">
                            <img class="avatar" :src="avatarImage(user)"/>
                            <i class="fa fa-circle online-status" v-if="user.isOnline"></i>
                            <span>{{user.alias}}</span>
                            <i class="fa fa-star mod-status status-owner" v-if="user.moderatorStatus === 'owner'"></i>
                            <i class="fa fa-star mod-status status-moderator" v-if="user.moderatorStatus === 'moderator'"></i>
                        </a>
                        <span class="moderator-controls" v-if="moderatorStatus === 'owner' || moderatorStatus === 'moderator'">
                            <a href="#promote-member" @click.prevent="promote(user)" v-if="user.moderatorStatus !== 'owner' && user.moderatorStatus !== 'moderator'">Promote</a>
                            <a href="#demote-member" @click.prevent="demote(user)" v-if="user.moderatorStatus === 'moderator' && user.id !== ownId">Demote</a>
                            <a href="#kick-member" @click.prevent="kick(user)" v-if="user.moderatorStatus !== 'owner' && user.moderatorStatus !== 'moderator'">Kick</a>
                        </span>
                    </li>
                </ul>
            </section>

            <section id="add-member" v-if="inviteMemberMode">
                <input type="text" placeholder="Search for a user..." v-model="inviteMemberValue"/>

                <h1 v-if="inviteMemberValue.length > 0 && filteredInviteMembersList.length === 0">No Matching Members Found</h1>
                <ul>
                    <li v-for="user in filteredInviteMembersList" :key="user.id">
                        <a href="#add" @click.prevent="addMember(user)" class="add-member-button"><i class="fa fa-plus-circle"></i></a>
                        <a :href="`/Profile/${user.stringUrl}`" target="_blank">
                            <img class="avatar" :src="avatarImage(user)"/>
                            <i class="fa fa-circle online-status" v-if="user.isOnline"></i>
                            <span>{{user.alias}}</span>
                            <i class="fa fa-star mod-status status-owner" v-if="user.moderatorStatus === 'owner'"></i>
                            <i class="fa fa-star mod-status status-moderator" v-if="user.moderatorStatus === 'moderator'"></i>
                        </a>
                    </li>
                </ul>
            </section>
        </template>

        <template v-if="leaveGroupMode">
            <div class="leave-group">
                <h1>Really leave this group?</h1>

                <div class="button-container">
                    <button @click.prevent="leaveGroupMode = false">Cancel</button>
                    <button @click.prevent="leaveGroup">Leave</button>
                </div>

                <template v-if="moderatorStatus === 'owner' && groupDetails.members.length > 1">
                    <h1>New Owner</h1>

                    <select v-model="newOwner">
                        <option v-for="user in groupDetails.members" v-if="user.id !== ownId" :value="user.id">{{user.alias}}</option>
                    </select>
                </template>
            </div>
        </template>

    </section>
</template>

<script>
    import axios from 'axios';
    import _ from 'lodash';

    export default {
        name: 'GroupDetails',

        data () {
            return {
                fetchedInitialGroupDetails: false,
                inviteMemberMode: false,
                leaveGroupMode: false,
                changeGroupNameMode: false,
                newGroupName: '',
                savingNewGroupName: false,
                newOwner: 0,
                inviteMemberValue: '',
                inviteMembersList: [],
                groupDetails: {
                    name: '',
                    members: [],
                    isPublic: 0
                },
                isSavingPublicStatus: false
            }
        },

        computed: {
            groupId(){
                return this.$store.state.activeChatModel.id.split('.')[1];
            },

            onlineUsers(){
                return this.$store.state.onlineUsersModel.onlineUsers;
            },

            ownId(){
                return this.$store.state.loggedUserModel.info.id;
            },

            moderatorStatus(){
                let status = '';

                this.groupDetails.members.forEach((member) => {
                    if (member.id === this.ownId) {
                        status = member.moderatorStatus;
                        return false;
                    }
                });

                return status;
            },

            filteredInviteMembersList(){
                let filteredList = [];

                this.inviteMembersList.forEach((member) => {
                    if (!this.memberIsInGroup(member)) {
                        filteredList.push(member)
                    }
                });

                return filteredList;
            }
        },

        methods: {
            avatarImage(user){
                let avatarId = new Date(user.avatarUpdate).getTime();

                if (user.hasAvatar) {
                    return `/userdata/avatars/${user.id}.jpg?v=${avatarId}`;
                } else {
                    return '/defaultProfilePic.png';
                }
            },

            fetchGroupDetails(){
                axios.get('/api/groups', {
                    params: {
                        groupId: this.groupId
                    }
                }).then(
                    (response) => {
                        if (response.data.errors) {
                            return;
                        }

                        this.fetchedInitialGroupDetails = true;
                        this.newGroupName = response.data.groupData.alias;

                        for (let i = 0; i < response.data.members.length; i++) {
                            if (response.data.members[i].id !== this.ownId) {
                                this.newOwner = response.data.members[i].id;
                                break;
                            }
                        }

                        this.groupDetails = {
                            name: response.data.groupData.alias,
                            members: response.data.members,
                            isPublic: response.data.groupData.isPublic
                        }
                    }
                );
            },

            updateGroupName(){
                this.newGroupName = this.newGroupName.trim();

                if (this.newGroupName === '') {
                    return;
                }

                this.savingNewGroupName = true;

                axios.post('/api/groups/updateGroupName', {
                    groupId: this.groupId,
                    groupName: this.newGroupName
                });
            },

            leaveGroup(){
                axios.post('/api/groups/leaveGroup', {
                    groupId: this.groupId,
                    newOwner: this.newOwner
                });
            },

            memberIsInGroup(user){
                let isInGroup = false;

                this.groupDetails.members.forEach(function (member) {
                    if (member.id === user.id) {
                        isInGroup = true;
                        return false;
                    }
                });

                return isInGroup;
            },

            fetchMatchingMembers: _.debounce(
                function () {
                    this.inviteMemberValue = this.inviteMemberValue.trim();
                    if (this.inviteMemberValue === '') {
                        return;
                    }

                    axios.get('/api/member/search', {
                        params: {
                            searchValue: this.inviteMemberValue
                        }
                    }).then(
                        (response) => {
                            if (!response.data.errors) {
                                this.inviteMembersList = response.data;
                            }
                        }
                    )
                },
                500),

            addMember(user){
                axios.post('/api/groups/addMember', {
                    groupId: this.groupId,
                    memberId: user.id
                });
            },

            kick(user){
                axios.post('/api/groups/kickMember', {
                    groupId: this.groupId,
                    memberId: user.id
                });
            },

            promote(user){
                axios.post('/api/groups/promoteMember', {
                    groupId: this.groupId,
                    memberId: user.id
                });
            },

            demote(user){
                axios.post('/api/groups/demoteMember', {
                    groupId: this.groupId,
                    memberId: user.id
                });
            },

            changePublicStatus(publicStatus){
                if (this.isSavingPublicStatus) {
                    return;
                }

                this.$set(this.groupDetails, 'isPublic', publicStatus);
                this.isSavingPublicStatus = true;

                axios.post('/api/groups/setPublicStatus', {
                    groupId: this.groupId,
                    publicStatus: publicStatus ? 1 : 0
                }).then(
                    (response) => {
                        this.isSavingPublicStatus = false;
                    },
                    (response) => {
                        this.isSavingPublicStatus = false;
                    }
                );
            }
        },


        mounted()
        {
            this.fetchGroupDetails();
        }
        ,

        watch: {
            'groupId'()
            {
                this.changeGroupNameMode = false;
                this.leaveGroupMode = false;
                this.inviteMemberMode = false;
                this.fetchGroupDetails();
            },

            'inviteMemberValue'(){
                this.fetchMatchingMembers();
            }
        }
        ,

        sockets: {
            'groupDataUpdated'()
            {
                this.savingNewGroupName = false;
                this.changeGroupNameMode = false;
                this.fetchGroupDetails();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// GroupDetails.vue?3764157b